import { CsvInventoryMapper } from '../../common/mappers/CsvInventoryMapper';
import { CsvPayload } from '../../common/models/CsvPayload';
import { ProjectCsvData } from '../models/ProjectCsvData';

export class ProjectCsvMapper {
  private readonly inventoryMapper = new CsvInventoryMapper();

  mapGQLModel(data: any): ProjectCsvData {
    const inventory = this.inventoryMapper.mapGQLModel(data.inventory);
    const issues = this.mapIssues(data.vulnerabilities);

    return new ProjectCsvData(inventory, issues);
  }

  private mapIssues(data: any): CsvPayload {
    const issueSummaryHeaders = ['Number', 'Title', 'Explanation', 'Severity', 'Reports impacted'];
    const issues = (data.edges ?? []).map(({ node }: any) => {
      const { number, title, shortExplanation, severity, numberOfSlots } = node ?? {};
      return [number, title, shortExplanation, severity, numberOfSlots];
    });

    return new CsvPayload(issueSummaryHeaders, issues);
  }
}
